import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const OnboardingPage = ({ intl }) => (
  <div className="set-languages overlay-container">
    <div className="flex-column items-center">
      <div className="user-form-back">
        <Link to="/">
          <FontAwesomeIcon icon="arrow-left" size="2x" />
        </Link>
      </div>
      <h2>{intl.formatMessage(messages.signUpAs)}</h2>
      <div className="role-field">
        <Link to="/first-list?type=list">
          <div className="role-item-field">
            <img src="/assets/icons/student.png" alt="I am student, self-taugh" />
            {intl.formatMessage(messages.student)}
          </div>
        </Link>
        <Link to="/first-test">
          <div className="role-item-field">
            <img src="/assets/icons/educator.png" alt="I am teacher" />
            {intl.formatMessage(messages.teacher)}
          </div>
        </Link>
      </div>
    </div>
  </div>
)

OnboardingPage.propTypes = {
  intl: PropTypes.object.isRequired,
}

const enhance = compose(
  connect(() => ({ }), { }),
  injectIntl,
)

export default enhance(OnboardingPage)

const messages = defineMessages({
  greeting: {
    id: 'setLanguages.form.greeting',
    defaultMessage: 'Dobrý deň',
  },
  signUpAs: {
    id: 'setLanguages.form.signUpAs',
    defaultMessage: 'Ste študent alebo učiteľ?',
  },
  teacher: {
    id: 'base.teacher',
    defaultMessage: 'Som učiteľ',
  },
  student: {
    id: 'base.student',
    defaultMessage: 'Som študent, samouk',
  },
})


// WEBPACK FOOTER //
// ./src/browser/pages/OnboardingPage.js